<template>
  <button
    class="ppv-chip"
    :class="[
      variantClass,
      { selected: selected, 'ppv-chip--icon': !!icon || hasDefaultSlot },
    ]"
    :disabled="disabled"
    @click="handleClick"
  >
    <v-icon v-if="icon" class="mr-1">{{ icon }}</v-icon>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'PpvChip',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'track', 'disease', 'outline', 'more', 'triage'].includes(v),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    variantClass() {
      const map = {
        track: 'ppv-chip--track',
        disease: 'ppv-chip--disease ppv-chip--outline',
        outline: 'ppv-chip--outline',
        more: 'ppv-chip--more',
        triage: 'ppv-chip--triage',
      }
      return map[this.variant] || ''
    },
    hasDefaultSlot() {
      return !!this.$slots.default
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.ppv-chip {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #eaedf2;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}
.ppv-chip:hover {
  border-color: #4b91ac;
}
.ppv-chip.selected {
  background: #1a2340;
  color: #fff;
  border-color: #1a2340;
  font-weight: 600;
}
.ppv-chip--icon {
  gap: 8px;
  padding: 6px 14px;
}
.ppv-chip .v-icon {
  color: #4a5568 !important;
  font-size: 14px !important;
}
.ppv-chip.selected .v-icon {
  color: #fff !important;
}
.ppv-chip--track {
  border-radius: 6px;
}
.ppv-chip--track.selected {
  background: #eef2ff;
  color: #5850ec;
  border-color: #c3dafe;
}
.ppv-chip--track .v-icon {
  color: #4a5568 !important;
  font-size: 16px !important;
}
.ppv-chip--track.selected .v-icon {
  color: #5850ec !important;
}
.ppv-chip--outline {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.ppv-chip--disease {
  border-radius: 6px;
}
.ppv-chip--disease.selected {
  background: #e6fffa;
  color: #2c7a8c;
  border-color: #b2f5ea;
}
.ppv-chip--disease.selected .v-icon {
  color: #2c7a8c !important;
  font-size: 14px !important;
}
.ppv-chip--more {
  border-color: transparent;
  background: transparent;
  color: #4b91ac;
  font-weight: 600;
}
.ppv-chip--more .v-icon {
  color: #4b91ac !important;
  font-size: 16px !important;
}
.ppv-chip--triage {
  border-radius: 6px;
}
.ppv-chip--triage.selected {
  background: #fff7ed;
  color: #c2410c;
  border-color: #fdba74;
}
.ppv-chip--triage .v-icon {
  color: #4a5568 !important;
  font-size: 16px !important;
}
.ppv-chip--triage.selected .v-icon {
  color: #c2410c !important;
}
.ppv-chip:disabled {
  opacity: 0.5;
  background: #f1f5f9;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 6px;
  cursor: not-allowed;
}
</style>
